import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ProductFeed from "./components/product/ProductFeed";
import AddProduct from "./components/product/AddProduct";
import Navigation from "./components/main/Navigation";
import SignUp from "./components/authentication/SignUp";
import LogIn from "./components/authentication/LogIn";
import Cart from "./components/cart/Cart";
import Checkout from "./components/payment/Checkout";
import './App.css';
import { AuthProvider } from "./components/context/usercontext";
import { CartProvider } from "./components/context/cartcontext";
import { useState } from "react";


function App() {
    const [uname, setUname] = useState('');
    return (
        <div className = 'app'>
            <Router>
            <AuthProvider>
                <CartProvider>
                        <Navigation uname = {uname} />
                        <Switch>
                            <Route path = '/signup' exact>
                                <SignUp setUname = {setUname}/>
                            </Route>
                            <Route path = '/login' exact component = {LogIn}/>
                            <Route path = '/cart' exact component = {Cart}/>
                            <Route path = '/checkout' exact component = {Checkout}/>
                            <Route path = '/addproduct' exact component = {AddProduct}/>
                            <Route path = '/' exact>
                                <ProductFeed />
                            </Route>
                        </Switch>
                    
                </CartProvider>
            </AuthProvider>
            </Router>
        </div>
    );
}

export default App;
